import { render, staticRenderFns } from "./FullReductionPromotionDetails.vue?vue&type=template&id=4cef3a6c&scoped=true&"
import script from "./FullReductionPromotionDetails.vue?vue&type=script&lang=js&"
export * from "./FullReductionPromotionDetails.vue?vue&type=script&lang=js&"
import style0 from "./FullReductionPromotionDetails.vue?vue&type=style&index=0&id=4cef3a6c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef3a6c",
  null
  
)

export default component.exports